import React from 'react';
import classNames from 'classnames';
import { Button, Close, makeStyles } from "../../index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        height: '100%',
        minWidth: 0,
        padding: 0,
        borderRadius: theme.shape.borderRadius,
        '&.SnButton-light': {
            backgroundColor: 'transparent',
        },
    },
}); });
/**
 * クリアボタンコンポーネント。
 *
 * - 親をrelativeにして、ClearButtonはabsoluteで位置を決める。
 * - 位置を決定する際、重ねるボタンにborderがある場合はtheme.shape.borderWidthの分内側に配置する。
 */
export var ClearButton = React.memo(function (props) {
    var onClick = props.onClick, className = props.className;
    var classes = useStyles();
    return (React.createElement(Button, { className: classNames(classes.root, className), onClick: onClick },
        React.createElement(Close, null)));
});
